import { motion } from 'motion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, Text } from '@frontend/design-system';
import { useStackedCardWizardContext } from './stacked-card-wizard-context';

export const StackedCardWizardFooter = () => {
  const { t } = useTranslation('schedule-onboarding');
  const { currentStep, totalSteps, nextStep, prevStep, isFirstStep, canGoNext, isLoading } =
    useStackedCardWizardContext();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.3, duration: 0.3 }}
      css={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}
    >
      <div>
        {!isFirstStep && (
          <Button variant='secondary' iconName='back' onClick={prevStep}>
            {t('Back')}
          </Button>
        )}
      </div>
      <div css={{ display: 'flex', alignItems: 'center', gap: theme.spacing(2) }}>
        <Text size='medium' color='light'>
          {t('Step {{current}} of {{total}}', { current: currentStep + 1, total: totalSteps })}
        </Text>
        <Button onClick={nextStep} disabled={!canGoNext || isLoading} loading={isLoading}>
          {t('Next')}
        </Button>
      </div>
    </motion.div>
  );
};
